import dummyMutation from './dummyMutation';
import setRequestsStatus from './setRequestsStatus';
export default {
    dummyMutation,
    setRequestsStatus,
};
